import { useTranslation } from "next-i18next";
import { useMemo } from "react";

import { CurrentUserSubscriptionStatusEnum } from "@/generated/generated-hooks";

export const useSubscriptionCardButtonStatus = (
  currentUserSubscriptionStatus: CurrentUserSubscriptionStatusEnum,
  isUnlockExpiredContent: boolean,
) => {
  const { t } = useTranslation("subscrtionPlan");

  return useMemo(() => {
    if (isUnlockExpiredContent) {
      return {
        isDisabled: false,
        label: t("subscriptionPlan:subscribe"),
        isInvalid: false,
      };
    }

    if (
      currentUserSubscriptionStatus ===
      CurrentUserSubscriptionStatusEnum.InvalidSubscriptionPlan
    ) {
      return {
        isDisabled: true,
        label: t("subscriptionPlan:subscribe"),
        isInvalid: true,
      };
    }

    if (
      currentUserSubscriptionStatus ===
      CurrentUserSubscriptionStatusEnum.Subscribe
    ) {
      return {
        isDisabled: false,
        label: t("subscriptionPlan:subscribe"),
        isInvalid: false,
      };
    }

    if (
      currentUserSubscriptionStatus ===
      CurrentUserSubscriptionStatusEnum.SubscribedWithHigherPrice
    ) {
      return {
        isDisabled: true,
        label: t("subscriptionPlan:subscribedWithHigherPrice"),
        isInvalid: false,
      };
    }

    if (
      currentUserSubscriptionStatus ===
      CurrentUserSubscriptionStatusEnum.Subscribed
    ) {
      return {
        isDisabled: true,
        label: t("subscriptionPlan:subscribed"),
        isInvalid: false,
      };
    }

    return {
      isDisabled: false,
      label: t("subscriptionPlan:subscribe"),
      isInvalid: false,
    };
  }, [currentUserSubscriptionStatus, t, isUnlockExpiredContent]);
};
